<template>
  <div class="p-6 kreditgenie-bg-overlay-darkgreen min-h-screen flex justify-center items-center">
    <div class="w-full max-w-md">
      <logo class="block mx-auto w-full max-w-xs fill-white" height="50" />
      <form class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="login">
        <div class="px-10 py-12">
          <h1 class="text-center font-bold text-3xl">Geben Sie den Code aus Ihrem Postfach ein</h1>
          <div class="mx-auto mt-6 w-24 border-b-2" />
          <text-input
            v-model="form.verification_code"
            :error="form.errors.verification_code"
            class="mt-10" label="Bestätigungscode"
            type="text"
            autofocus
            autocapitalize="off"
            required
          />
        </div>
        <div class="px-10 py-4 bg-gray-100 border-t border-gray-100 flex">
          <loading-button :loading="form.processing" class="ml-auto btn-green" type="submit">
            Vorgehen
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: {title: 'Code verification'},
  components: {
    LoadingButton,
    Logo,
    TextInput,
  },
  props: {
    data: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        email: this.data.email,
        password: this.data.password,
        remember: this.data.remember,
        verification_code: '',
      }),
    }
  },
  methods: {
    login() {
      this.form.post(this.route('login.store'))
    },
  },
}
</script>
